module.exports = __webpack_public_path__ + "img/Soldout-pc.14f2bb7.png";